import React from 'react';

export default function Link({ url, title, className }) {
    return <a href={url} dangerouslySetInnerHTML={{ __html : title }} className={className}/>;
}
